export const modalities = ['video', 'phone', 'text', 'chat']
